import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isLondonBookFairActive, isSummerWelcomeActive } from '../utils/dateUtils';

/**
 * HomePage component that handles date-based routing to themed dashboards
 * Priority: LBF > Summer Welcome > Regular Dashboard
 */
const HomePage = ({ user, organization }) => {
    const navigate = useNavigate();
    
    useEffect(() => {
        // Check for active promotional periods
        const lbfActive = isLondonBookFairActive();
        const summerActive = isSummerWelcomeActive();
        
        console.log('HomePage: Date check results:', {
            lbfActive,
            summerActive,
            currentDate: new Date().toISOString()
        });
        
        // Priority: LBF first, then Summer Welcome, then regular dashboard
        if (lbfActive) {
            console.log('HomePage: Redirecting to LBF dashboard');
            navigate('/lbf');
        /*
        } else if (summerActive) {
            console.log('HomePage: Redirecting to Summer Welcome dashboard');
            navigate('/summer-welcome');
        */
        } else {
            console.log('HomePage: Redirecting to regular dashboard');
            navigate('/dashboard');
        }
    }, [navigate]);
    
    // Show loading while determining which dashboard to show
    return (
        <div className="flex items-center justify-center min-h-screen">
            <div className="text-lg">Loading...</div>
        </div>
    );
};

export default HomePage; 